import { render, staticRenderFns } from "./VerifyReceiptQuantity.vue?vue&type=template&id=80d64262"
import script from "./VerifyReceiptQuantity.vue?vue&type=script&lang=js"
export * from "./VerifyReceiptQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports